"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIIntegrationSecretStatus = void 0;
function parseIIntegrationSecretStatus(data) {
    if (typeof data.modified_date === 'string')
        data.modified_date = new Date(data.modified_date);
    return data;
}
exports.parseIIntegrationSecretStatus = parseIIntegrationSecretStatus;
